<div class="sf-sav">
  <!-- Bal menüvel (SULINFORM) a bal sávot az oldal saját fejlécének hamburgere nyitja; saját szekciókkal a saját panel. -->
  <button type="button" class="sf-mobil csak-mobil" *ngIf="szekciokkal" (click)="mobilNyitva = !mobilNyitva; $event.stopPropagation()"
          [attr.aria-expanded]="mobilNyitva" aria-label="Menü">
    <ion-icon name="menu-outline"></ion-icon>
  </button>
  <button type="button" class="sf-marka" (click)="kezdolap()" title="Kezdőlap">
    <img class="sf-logo" [src]="ikon" alt="">
    <span class="sf-marka-szoveg">SULINFORM</span>
  </button>

  <nav class="sf-szekciok csak-asztal" aria-label="Főmenü" *ngIf="szekciokkal">
    <div class="sf-szekcio" *ngFor="let s of szekciok">
      <button type="button" class="sf-ful" [class.aktiv]="s.kulcs === aktivSzekcio" [class.nyitva]="nyitott === s.kulcs"
              [attr.aria-expanded]="nyitott === s.kulcs" (click)="valt(s.kulcs, $event)" [title]="s.cim">
        <ion-icon [name]="s.ikon"></ion-icon><span>{{ s.cim }}</span>
        <span class="sf-jelzes" *ngIf="vanJelzes(s)">{{ olvasatlan }}</span>
        <ion-icon class="sf-nyil" name="chevron-down"></ion-icon>
      </button>
      <div class="sf-lenyilo" *ngIf="nyitott === s.kulcs" (click)="$event.stopPropagation()">
        <div class="sf-blokk" *ngFor="let b of s.blokkok">
          <div class="sf-blokk-fej" *ngIf="b.fejlec">{{ b.fejlec }}</div>
          <button type="button" class="sf-pont" *ngFor="let p of b.pontok" [disabled]="p.tiltott"
                  [class.aktiv]="!p.kulso && p.url === aktivUrl" (click)="nyit(p)">
            <ion-icon [name]="p.ikon"></ion-icon><span>{{ p.cim }}</span>
            <ion-icon *ngIf="p.kulso" class="sf-kulso" name="open-outline"></ion-icon>
            <span class="sf-jelzes" *ngIf="p.url === '/message' && olvasatlan">{{ olvasatlan }}</span>
          </button>
        </div>
      </div>
    </div>
  </nav>

  <div class="sf-ter"></div>

  <div class="sf-ugras">
    <label class="sf-ugras-mezo">
      <ion-icon name="search-outline" aria-hidden="true"></ion-icon>
      <span class="sr-only">Ugrás menüpontra</span>
      <input #ugrasMezo type="search" [(ngModel)]="q" (ngModelChange)="keres()" (keydown)="ugrasBillentyu($event)"
             placeholder="Ugrás… (Ctrl K)" autocomplete="off">
    </label>
    <div class="sf-talalatok" *ngIf="q.trim()">
      <button type="button" *ngFor="let t of talalatok; let i = index" class="sf-talalat" [class.kijelolt]="i === kijelolt"
              (click)="nyit(t)" (mouseenter)="kijelolt = i">
        <span class="sf-talalat-cim">{{ t.cim }}</span><span class="sf-talalat-ut">{{ t.szekcio }}</span>
      </button>
      <p class="sf-nincs" *ngIf="!talalatok.length">Nincs ilyen menüpont.</p>
    </div>
  </div>

  <select class="sf-tanev csak-asztal" *ngIf="tanevek?.length" [ngModel]="aktivTanevId" (ngModelChange)="tanevValasztas($event)" title="Tanév">
    <option *ngFor="let t of tanevek" [value]="t.id">{{ t.name }}</option>
  </select>
  <label class="sf-szinmod" title="A menü és a fejléc színe: sötét, világos vagy a rendszer szerint (a tartalom mindig világos)">
    <ion-icon [name]="szinmod === 'sotet' ? 'moon-outline' : (szinmod === 'rendszer' ? 'contrast-outline' : 'sunny-outline')" aria-hidden="true"></ion-icon>
    <span class="sr-only">A menü és a fejléc színe</span>
    <select [ngModel]="szinmod" (ngModelChange)="szinmodValt($event)">
      <option value="sotet">Sötét</option>
      <option value="vilagos">Világos</option>
      <option value="rendszer">Rendszer</option>
    </select>
  </label>
  <app-profil-menu [sotetFejlec]="!keretVilagos"></app-profil-menu>
</div>

<!-- Telefonon: minden szekció egy panelben. -->
<div class="sf-mobil-panel" *ngIf="szekciokkal && mobilNyitva" (click)="$event.stopPropagation()">
  <select class="sf-tanev" *ngIf="tanevek?.length" [ngModel]="aktivTanevId" (ngModelChange)="tanevValasztas($event)" title="Tanév">
    <option *ngFor="let t of tanevek" [value]="t.id">{{ t.name }}</option>
  </select>
  <div class="sf-mobil-szekcio" *ngFor="let s of szekciok">
    <div class="sf-mobil-cim"><ion-icon [name]="s.ikon"></ion-icon>{{ s.cim }}</div>
    <ng-container *ngFor="let b of s.blokkok">
      <div class="sf-blokk-fej" *ngIf="b.fejlec">{{ b.fejlec }}</div>
      <button type="button" class="sf-pont" *ngFor="let p of b.pontok" [disabled]="p.tiltott"
              [class.aktiv]="!p.kulso && p.url === aktivUrl" (click)="nyit(p)">
        <ion-icon [name]="p.ikon"></ion-icon><span>{{ p.cim }}</span>
        <span class="sf-jelzes" *ngIf="p.url === '/message' && olvasatlan">{{ olvasatlan }}</span>
      </button>
    </ng-container>
  </div>
</div>
